const copyer = {
  state: {
    openAccountDialogShow: false,
    mamSubscrpitDialogShow: false,
    socialSubscrpitDialogShow: false,
    mamSubAccountEditSubscrpitDialogShow: false,
    masterAccountEditSubscrpitDialogShow: false,//mam主账户和social子账户的编辑订阅
    masterAccountEditSubscrpitDialogType: 'mam',
    renew: false, // 订阅框的续订(mam不需要续订,social订阅才有)
    agreementFile: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/copyAgreement_zh.pdf',
    agreementFileEn: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/copyAgreement_en.pdf',
    detailsIsMaster: true,
    copyingSelectData: [
      //订阅关系id,
      //跟随者login
      // 管理资金managementAmount,杠杆copyLeverage
    ],
    currentMasterMtId: 0,
    copyingSelectMultiple: false, // 是否勾选
    masterAccountEditSubscrpitParams:{
      // social子账户的续订和编辑订阅都可以用
      copyLoginId: '',
      copyType: 1,
      copyValue: 0.2,
      copyMaxNum: '',
      copyMaxLots: '',
      copyStatus: 1,
      isRenew: 1,
    },
    mamSubEditSubscrpitParams:{
      mamCopyLogin: '',
      balance: '',
      trusteeship: '',
      autoRenew: false,
      ids: '',
    },
    renewAccountList:[
      {
        copyLogin: '',
        copyMtId: '',
        copyBalances: '',
      }
    ],
  },

  mutations: {
    setOpenAccountDialogShow(state,flag){
        state.openAccountDialogShow = flag;
    },
    setSocialSubscrpitDialogShow(state,flag){
        state.socialSubscrpitDialogShow = flag;
    },
    setMamSubscrpitDialogShow(state,flag){
        state.mamSubscrpitDialogShow = flag;
    },
    setMamSubAccountEditSubscrpitDialogShow (state,flag){
      state.mamSubAccountEditSubscrpitDialogShow = flag;
    },
    setMasterAccountEditSubscrpitDialogShow (state,flag){
      state.masterAccountEditSubscrpitDialogShow = flag;
    },
    setMasterAccountEditSubscrpitDialogType(state,type){
      state.masterAccountEditSubscrpitDialogType = type;
    },
    setRenew(state,flag){
      state.renew = flag;
    },
    setDetailsIsMaster(state,flag){
      state.detailsIsMaster = flag;
    },
    setCopyingSelectData(state,dataArr){
      state.copyingSelectData = dataArr;
    },
    setMasterAccountEditSubscrpitParams(state,copyParams){
      state.masterAccountEditSubscrpitParams = copyParams;
    },
    setCopyingSelectMultiple(state,flag){
      state.copyingSelectMultiple = flag;
    },
    setCurrentMasterMtId(state,mtId){
      state.currentMasterMtId = mtId;
    },
    setMamSubEditSubscrpitParams(state,info){
      state.mamSubEditSubscrpitParams = info;
    },
    setRenewAccountList(state,list){
      state.renewAccountList = list;
    },
  },

  actions: {
  },
  getters:{
    openAccountDialogShow: state => state.openAccountDialogShow,
    mamSubscrpitDialogShow: state => state.mamSubscrpitDialogShow,
    socialSubscrpitDialogShow: state => state.socialSubscrpitDialogShow,
    mamSubAccountEditSubscrpitDialogShow: state => state.mamSubAccountEditSubscrpitDialogShow,
    masterAccountEditSubscrpitDialogShow: state => state.masterAccountEditSubscrpitDialogShow,
    agreementFile: state => state.agreementFile,
    agreementFileEn: state => state.agreementFileEn,
    masterAccountEditSubscrpitDialogType: state => state.masterAccountEditSubscrpitDialogType,
    renew: state => state.renew,
    detailsIsMaster: state => state.detailsIsMaster,
    copyingSelectData: state => state.copyingSelectData,
    masterAccountEditSubscrpitParams: state => state.masterAccountEditSubscrpitParams,
    copyingSelectMultiple: state => state.copyingSelectMultiple,
    currentMasterMtId: state => state.currentMasterMtId,
    mamSubEditSubscrpitParams: state => state.mamSubEditSubscrpitParams,
    renewAccountList: state => state.renewAccountList,
  }
};

export default copyer;
